<!--文件名称-->
<template>
    <div>
        <div class="food">
            <ul>
                <li @click.stop="skipPage(0)"><img src="../../assets/iphone/icon14.png" /><span>首页</span></li>
                <li><a @click="modal2=true"><img src="../../assets/iphone/icon15.png" /><span>电话</span></a></li>
                <li @click="openMap"><img src="../../assets/iphone/icon16.png" /><span>位置</span></li>
            </ul>
        </div>

        <div class="">
            <BackTop :height="200" :bottom="80" :right="30" :duration="0"></BackTop>
        </div>

        <div>
            <Modal v-model="modal2" title="点击拨打电话"  :styles="{top: '100vh',marginTop:'-300px',textAlign:'center'}" width="80%" footer-hide>
                <ul class="telList">
                    <li><a href="tel:0516-83396008">0516-83396008（总台）</a></li>
                    <li><a href="tel:0516-83396280">0516-83396280（招聘）</a></li>
                </ul>
            </Modal>
        </div>
    </div>
</template>

<script>
import { GetContentByClassId } from "@/api";
export default {
    inject: ["skipPage"],
    data() {
        return {
            content: {},
            modal2:false
        };
    },
    mounted() {
        this.GetContentByClassId()
    },
    methods: {
        //获取坐标信息
        GetContentByClassId() {
            GetContentByClassId({ scode: 232 }).then((res) => {
                this.content = res;
            });
        },

        //打开百度地图
        openMap() {
            let vm = this;
            let lngs = vm.content.subtitle.split(",");
            let baiduUrl = `marker?location=${lngs[1]},${lngs[0]}&title=${vm.content.keywords}&content=${vm.content.enclosure}`;
            let urlCollect = `https://api.map.baidu.com/${baiduUrl}&output=html&src=webapp.baidu.openAPIdemo`;
            window.open(urlCollect)
        }



    },
};
</script>

<style scoped lang="less">

.telList{
    list-style: none;
    li{
        line-height: .8rem;
        font-size: .32rem;
        font-family: Arial, Helvetica, sans-serif;
        text-align: center;
        &:first-child{
            border-bottom: 1px solid rgba(0, 0, 0, .05);
        }
        a{
            color: #333;
        }
    }
}
.food {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 59;
    background-color: #fff;

    ul {
        height: 1.2rem;
        display: flex;
        list-style: none;
        background-color: #fff;
        padding: 0 .3rem;
        box-shadow: 0px -1px 0px 0px #E7E7E7;

        li {
            text-align: center;
            flex: 1;
            padding: .2rem 0;

            img {
                width: .5rem;
            }

            span {
                font-size: .22rem;
                line-height: .22rem;
                display: block;
                padding-top: .08rem;
                color: #000;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/iphone/Footer.vue